import script from "./FisheyeViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./FisheyeViewer.vue?vue&type=script&lang=ts&setup=true"

import "./FisheyeViewer.vue?vue&type=style&index=0&id=79e644a8&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e644a8"]])

export default __exports__